import { buildProps as e } from "./index601.js";
const t = e({
  currentPage: {
    type: Number,
    default: 1
  },
  pageCount: {
    type: Number,
    required: !0
  },
  pagerCount: {
    type: Number,
    default: 7
  },
  disabled: Boolean
});
export {
  t as paginationPagerProps
};
